export const ITEM_WIDTH = 100;
export const LIMIT_TO_SWIPE = 25;
export const IMG_TYPE = 'img';
export const PLAN_TYPE = 'plan';
export const VIDEO_TYPE = 'video';
export const MAP_TYPE = 'map';
export const V360_TYPE = 'viewer360';
export const OTHER_ROOMS_TYPE = 'other-rooms';
export const DEFAULT_LOCALE = 'en';

export const FULL_SCREEN_TRACKS = [
  IMG_TYPE,
  PLAN_TYPE,
  VIDEO_TYPE,
  MAP_TYPE,
  V360_TYPE
];

export const KEYS = {
  NEXT_ARROW: 39,
  PREV_ARROW: 37
};

export default {
  ITEM_WIDTH,
  LIMIT_TO_SWIPE,
  KEYS,
  IMG_TYPE,
  PLAN_TYPE,
  VIDEO_TYPE,
  MAP_TYPE,
  V360_TYPE,
  DEFAULT_LOCALE,
  FULL_SCREEN_TRACKS
};
